<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

  <!-- HEADER -->

  <div class="header mat-fuse-dark-400-bg px-24" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
    <div fxLayout="column" fxLayoutAlign="center start">
      <div class="black-fg" fxLayout="row" fxLayoutAlign="start center">
        <a [routerLink]="['/main/dashboard']" class="mt-3">
          <mat-icon class="secondary-text s-18">home</mat-icon>
        </a>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <a href="javascript:void(0)"><span class="secondary-text">Change Password</span></a>
      </div>
    </div>
  </div>


  <!-- / HEADER -->
  <!-- CONTENT -->
  <div class="content p-24">
    <div fxLayout="column" fxLayoutAlign="start start" fxLayout.gt-md="row">
      <form class="mat-white-bg mat-elevation-z4 p-24 mr-24 mb-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form" [formGroup]="frmChangePassword" (submit)="onSubmit()" novalidate>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <div fxFlex="100" class="mb-20">
            @if(apiResponseErrorMessage!=null){
            <div class="message-box error">
              {{apiResponseErrorMessage}}
            </div>
          }
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field fxFlex="100">
            <input type="password" matInput placeholder="Enter Current Password" parent="true" required color="primary" formControlName="currentPassword">
            @if(frmChangePassword.get('currentPassword').hasError('required')){
            <mat-error>
              Current Password is required
            </mat-error>
          }
          
            <!--<mat-error *ngIf="!frmChangePassword.get('currentPassword').hasError('required') && frmChangePassword.get('currentPassword').hasError('invalidPassword')">
              Minimum 6 characters,and combination of Alphanumeric and special character.
            </mat-error>-->

          </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field fxFlex="100">
            <input type="password" matInput placeholder="Enter New Password" required color="primary" formControlName="newPassword">
            <mat-error>
              @if(!frmChangePassword.get('newPassword').hasError('required') && frmChangePassword.get('newPassword').hasError('invalidPassword')){
              <span>Minimum 6 characters,and combination of Alphanumeric and special character.</span>
            }
              @if(frmChangePassword.get('newPassword').hasError('required')){
              <span>
                New Password is required
              </span>
            }
            </mat-error>
          </mat-form-field>

        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field fxFlex="100">
            <input type="password" matInput placeholder="Enter Confirm Password" required color="primary" formControlName="confirmPassword">
          <mat-error>
            @if(!frmChangePassword.get('confirmPassword').hasError('required') && frmChangePassword.get('confirmPassword').hasError('passwordsNotMatching')){
            <span>
              Passwords and Confirm Password are not same.
            </span>
          }
            @if(frmChangePassword.get('confirmPassword').hasError('required')){
            <span>
              Confirm Password is required
            </span>
          }
          </mat-error>
          </mat-form-field>
        </div>
        <div class="pt-24" fxLayout="row" fxLayoutAlign="end center">
          <button mat-raised-button type="submit" color="primary" [disabled]="!frmChangePassword.valid||isSubmitBtnDisabled">
            Change Password
          </button>
        </div>
      </form>
      <!-- / REACTIVE FORM EXAMPLE -->
    </div>
  </div>
  <!-- / CONTENT -->
</div>


